import Model, { attr, belongsTo } from '@ember-data/model';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class SecurityDepositSettingModel extends Model {
  @attr('number') amount!: number;
  @attr('boolean') enabled!: boolean;
  @attr('string') provider!: 'safeguest' | 'uplisting' | null;

  @belongsTo('property', { inverse: null, async: false })
  property!: ModelRegistry['property'];
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'security-deposit-setting': SecurityDepositSettingModel;
  }
}
